/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Model_Access_Level_Teams_HintInputs */



/**
* | output |
* | --- |
* | "Only members of the teams below can select this model." |
*
* @param {Model_Access_Level_Teams_HintInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const model_access_level_teams_hint = /** @type {((inputs?: Model_Access_Level_Teams_HintInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Model_Access_Level_Teams_HintInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Nur Mitglieder der unten aufgeführten Teams können dieses Modell auswählen.")
	return /** @type {LocalizedString} */ ("Only members of the teams below can select this model.")
});